
type NoDataProps = {
    message?: string;
};
export default function NoData({ message }: NoDataProps) {
    console.log("message", message)
  return (
    <div style={{ margin: "130px" }}>
          <h1>{message}</h1>
    </div>
  );
}